import { create } from "zustand";


type LayoutState = {
	sidebar: boolean;

	openSidebar: () => void;
	closeSidebar: () => void;
};

export const useStoreLayout = create<LayoutState>((set) => ({
	sidebar: false,

	openSidebar: () => set(() => ({ sidebar: true })),
	closeSidebar: () => set(() => ({ sidebar: false }))
}));